import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          JobSearch
        </Link>
        
        <div className="nav-links">
          <Link to="/jobs" className="nav-link">
            Browse Jobs
          </Link>
          
          <a 
            href="https://shadee.searchingways.co.in" 
            target="_blank" 
            rel="noopener noreferrer"
            className="nav-link matrimony-link"
          >
            Matrimony
          </a>
          
          {user ? (
            <>
              {user.userType === 'employer' ? (
                <>
                  <Link to="/employer/dashboard" className="nav-link">
                    Dashboard
                  </Link>
                  <Link to="/employer/post-job" className="nav-link">
                    Post Job
                  </Link>
                </>
              ) : (
                <Link to="/jobseeker/dashboard" className="nav-link">
                  My Applications
                </Link>
              )}
              <span className="nav-user">Welcome, {user.name}</span>
              <button onClick={handleLogout} className="nav-logout">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link">
                Login
              </Link>
              <Link to="/register" className="nav-link">
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
